import useSWR from 'swr'

import * as T from 'types'

import { fetch } from '../fetchers'

export const useFieldSchema = (listing?: T.IListing) => {
  const mlsId = listing?.mlsList[0]?.mls?._id ?? ''
  const key = mlsId ? `/fieldSchema/${mlsId}` : null

  const response = useSWR<T.IFieldSchema>(key, fetch)
  return { ...response, fieldSchema: response.data }
}
